import { TagColor } from '@factorialco/deprecated-design-system'

export default function tagColor(
  incidenceStatus: string,
  isBookkeeperView: boolean,
  hasInhousePayroll: boolean
) {
  const TAG_COLORS: Record<string, TagColor> = {
    in_preparation: TagColor.champagne,
    'in-preparation': TagColor.champagne,
    to_do: TagColor.lime,
    'to-do': TagColor.lime,
    doing: TagColor.purple,
    done: TagColor.lime,
    discarded: TagColor.neutral,
  }

  const TAG_COLORS_INHOUSE: Record<string, TagColor> = {
    in_preparation: TagColor.champagne,
    'in-preparation': TagColor.champagne,
    to_do: TagColor.champagne,
    'to-do': TagColor.champagne,
    doing: TagColor.malibu,
    done: TagColor.lime,
    discarded: TagColor.neutral,
  }

  const TAG_COLORS_BK: Record<string, TagColor> = {
    in_preparation: TagColor.purple,
    'in-preparation': TagColor.purple,
    to_do: TagColor.radical,
    'to-do': TagColor.radical,
    doing: TagColor.champagne,
    done: TagColor.lime,
    discarded: TagColor.neutral,
  }

  if (isBookkeeperView) {
    return TAG_COLORS_BK[incidenceStatus] || TagColor.grey
  } else if (hasInhousePayroll) {
    return TAG_COLORS_INHOUSE[incidenceStatus] || TagColor.grey
  }
  return TAG_COLORS[incidenceStatus] || TagColor.grey
}

export const reopenedTagColor = () => TagColor.grey
